<div id="officeHomeRoot" [ngClass]="themeRootCssClass" *ngIf="viewInitializationCompleted">
    <div id="officeHome" class="pwa ms-fontWeight-regular ms-bgc-nla" [ngClass]="officeHomeClass">
        <div *ngIf="leftNavReact && !(onWacContentPage | async)">
            <ng-container ohpLazyView ngModulePath="left-nav-react#LeftNavReactModule"></ng-container>
        </div>
        <div *ngIf="appBarEnabled && !(onWacContentPage | async)">
            <div class="ms-bgc-d appbar-placeholder" id="appBar"></div>
            <ng-container ohpLazyView ngModulePath="appbar#AppBarModule"></ng-container>
        </div>
        <router-outlet name="install-wizard"></router-outlet>
        <ng-container *ngIf="loadFeatureCalloutModule" ohpLazyView ngModulePath="feature-callout#FeatureCalloutModule"></ng-container>
        <div id="officeHome__container" class="o365cs-base o365cst"
            [ngClass]="{
                'office-box-sizing': !onFeedPage,
                'left-nav-offset': leftNavReact,
                'appbar-offset': appBarEnabled,
                'ms-bgc-nla': !fluentThemeRefreshEnabled,
                'fluent-background-color': !fluentThemeRefreshEnabled,
                'fluentvnext-background': fluentThemeRefreshEnabled,
                'fluentvnext-background-shadow': fluentHeaderEnabled
            }">
            <ng-container *ngIf="showWorkspaceNav"
                        ohpLazyView
                        ngModulePath="workspace-nav#WorkspaceNavModule"></ng-container>
            <div id="officeHome__scroll-content" ohpScrollListener
                [ngClass]="{
                            'scroll-content': !(onWacContentPage | async),
                            'app-gallery-workspace-nav-offset': showWorkspaceNav,
                            'scroll-content--transform': !onMyContentPage && !(onWacContentPage | async)}"
                (dragover)="dragoverHandler($event)"
                (drop)="dropHandler($event)">
                <div id="officeHome__wrapper"
                    [ngStyle]="showBackgroundImage && !visualBackgroundEnabled ? backgroundStyle : ''"
                    [ngClass]="{ 'fluent-background': showBackgroundImage && !visualBackgroundEnabled, 'with-appbar-min-width': onAppGallery && appsModuleEnabled }"
                    (ohpResize)="onResize($event)">
                    <ng-container *ngIf="visualBackgroundEnabled" ohpLazyView ngModulePath="visual-background-react#VisualBackgroundReactModule"></ng-container>
                    <ng-container *ngIf="showAnnouncement" ohpLazyView ngModulePath="announcement#AnnouncementModule"></ng-container>
                    <div [ngStyle]="visualBackgroundEnabled ? visualOfficeWrapperStyle : ''">
                        <ng-container ohpLazyView ngModulePath="banner#BannerModule"></ng-container>
                        <ohp-hero *ngIf="!onMyContentPage && !onFeedPage"></ohp-hero>
                        <ng-container *ngIf="webVitalsEnabled || memoryProfilingEnabled" ohpLazyView ngModulePath="web-vitals#WebVitalsModule"></ng-container>
                        <router-outlet></router-outlet>
                        <ng-container ohpLazyView ngModulePath="feature-tooltip-container#FeatureTooltipContainerModule"></ng-container>
                        <ng-container ohpLazyView ngModulePath="context-menu#ContextMenuModule"></ng-container>
                        <ng-container *ngIf="actionContextMenuEnabled" ohpLazyView ngModulePath="action-context-menu-react#ActionContextMenuReactModule"></ng-container>
                    </div>
                </div>
            </div>
        </div>
        <ng-container ohpLazyView ngModulePath="upload-dialog#UploadDialogModule"></ng-container>
        <ng-container ohpLazyView ngModulePath="upload-local-file#UploadLocalFileModule"></ng-container>
        <ng-container ohpLazyView ngModulePath="error-dialog#ErrorDialogModule"></ng-container>
        <ng-container ohpLazyView ngModulePath="input-dialog#InputDialogModule"></ng-container>
        <ng-container ohpLazyView ngModulePath="allow-filesystem-access#AllowFileSystemAccessModule"></ng-container>
        <ng-container *ngIf="customPivots" ohpLazyView ngModulePath="confirmation-dialog-react#ConfirmationDialogReactModule"></ng-container>
        <ng-container *ngIf="createOneNotePageEnabled" ohpLazyView ngModulePath="create-onenote-page-dialog-react#CreateOneNotePageDialogReactModule"></ng-container>
        <ng-container *ngIf="taskModule" ohpLazyView ngModulePath="task-module-dialog-react#TaskModuleDialogReactModule"></ng-container>
        <ng-container *ngIf="toastContainer" ohpLazyView ngModulePath="toast-container-react#ToastContainerReactModule"></ng-container>
        <ng-container *ngIf="uploadV2" ohpLazyView ngModulePath="upload-react#UploadReactModule"></ng-container>
        <ng-container *ngIf="searchEnabled && !nativeSearchEnabled" ohpLazyView ngModulePath="auto-suggest#AutoSuggestModule"
                      [inputs]="{
                                    showFASTBreadcrumb: showFASTBreadcrumb
                                }">
        </ng-container>
    </div>
    <ng-container ohpLazyView ngModulePath="first-run-wrapper#FirstRunWrapperModule" *ngIf="firstRunEnabled"></ng-container>
    <ng-container *ngIf="loadTeachingUiReactModule" ohpLazyView ngModulePath="teaching-ui-react#TeachingUiReactModule"></ng-container>
    <ng-container *ngIf="onWacContentPage"
                  ohpLazyView
                  ngModulePath="share-control#ShareControlModule"
                  [inputs]="{
                      mobileShareMenu: false,
                      contentShareMenu: onWacContentPage
                  }">
    </ng-container>
    <ng-container *ngIf="nativeSearchEnabled" ohpLazyView ngModulePath="search-preload#SearchPreloadModule"></ng-container>
    <ng-container *ngIf="wacHostEnabled" ohpLazyView ngModulePath="wac-content#WacContentModule"></ng-container>
    <ng-container *ngIf="fluentThemeRefreshEnabled" ohpLazyView ngModulePath="fluent-theme-provider#FluentThemeProviderModule"></ng-container>
</div>
